module.exports = __webpack_public_path__ + "static/media/elliotgroup.7e86758c.png";